const CUSTOM_DATA_FIELD_PATTERN = /^custom_data\.(\d+)\.field_value$/;

/**
 * Builds a Spatie search2 filter object from a structure field name and typed value.
 * Maps `custom_data.N.field_value` to the `custom_data` array filter shape.
 */
export function buildAutocompleteFilter(
  fieldName: string,
  value: string,
): Record<string, unknown> {
  const match = CUSTOM_DATA_FIELD_PATTERN.exec(fieldName);

  if (match) {
    return {
      custom_data: [{ field_index: Number(match[1]), field_value: value }],
    };
  }

  return { [fieldName]: value };
}
